import { render, staticRenderFns } from "./InputButton.vue?vue&type=template&id=3299067c&scoped=true&"
import script from "./InputButton.vue?vue&type=script&lang=js&"
export * from "./InputButton.vue?vue&type=script&lang=js&"
import style0 from "./InputButton.vue?vue&type=style&index=0&id=3299067c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3299067c",
  null
  
)

export default component.exports